import { create } from 'zustand'
import { ExpenseCategory } from '@/types/expense'

interface ExpensesFormState {
  form: {
    file?: File
    category?: ExpenseCategory
    operation?: string
    total?: number
    percentage?: number
    date?: string
    reference?: string
    calculateVatExpense?: boolean
    documentSignedId?: string
    sgid?: string
  }
  setForm: (form: ExpensesFormState['form']) => void
}

export const useExpensesFormStore = create<ExpensesFormState>((set) => ({
  form: {},
  setForm: (newForm) => set({ form: newForm })
}))
